import factory from '../octicon.js';

// This is an auto-generated ES2015 icon from the modularize script. Please do not modify this file.
var inbox = factory('inbox', 14, 16, {"fill-rule":"evenodd","d":"M14 9l-1.13-7.14c-.08-.48-.5-.86-1-.86H2.13c-.5 0-.92.38-1 .86L0 9v5c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V9zm-3.28.55l-.44.89c-.17.34-.52.56-.91.56H4.61c-.38 0-.72-.22-.89-.55l-.44-.91c-.17-.33-.52-.55-.89-.55H1l1-7h10l1 7h-1.38c-.39 0-.73.22-.91.55l.01.01z"}, ["mail","todo","new","messages"]);

export default inbox;
